/* tslint:disable */
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
// noinspection ES6UnusedImports
import { Dictionary, EntityAdapter, EntitySelectors, EntityState } from '@ngrx/entity/src/models';
import { TypedReferenceData } from './models/typed-reference-data';
import { createEntityAdapter } from '@ngrx/entity';
import * as referenceDataActions from './reference-data.actions';
import { GenericReferenceData } from './models/generic-reference-data';
import { assign, map } from 'lodash';

export interface LocalState extends EntityState<TypedReferenceData<GenericReferenceData>> {
}

export const adapter: EntityAdapter<TypedReferenceData<GenericReferenceData>> =
  createEntityAdapter<TypedReferenceData<GenericReferenceData>>({
    selectId: (t: TypedReferenceData<GenericReferenceData>) => t.type,
  });

export const initialState: LocalState = adapter.getInitialState({
});

export function reducer<T extends GenericReferenceData>
  (state: LocalState = initialState, action: referenceDataActions.ReferenceDataActions<T>): LocalState {
  switch (action.type) {
    case referenceDataActions.ReferenceDataActionTypes.LoadReferenceDataItemSuccess: {
      adapter.removeOne((<referenceDataActions.LoadReferenceDataItemSuccessAction<T>>action).payload.type, state);
      return adapter.addOne((<referenceDataActions.LoadReferenceDataItemSuccessAction<T>>action).payload, state);
    }
    case referenceDataActions.ReferenceDataActionTypes.LoadReferenceDataSuccess: {
      adapter.removeMany(map(action.payload, (p: TypedReferenceData<T>) => p.type), state);
      return adapter.addMany((<referenceDataActions.LoadReferenceDataSuccessAction<T>>action).payload, state);
    }
    default: {
      return state;
    }
  }
}

export interface ReferenceDataState {
  referenceData: LocalState;
}

export const reducers: any = {
  referenceData: reducer,
};

export interface State {
  referenceDataState: ReferenceDataState;
}

export const getReferenceDataState: MemoizedSelector<any, any> = createFeatureSelector<ReferenceDataState>('referenceData');

export const getReferenceDataEntitiesState: MemoizedSelector<any, any> = createSelector(
  getReferenceDataState, state => state.referenceData,
);
export const {
  selectEntities: getReferenceDataEntities,
  selectAll: getAllReferenceData,
}: EntitySelectors<TypedReferenceData<GenericReferenceData>, any> = adapter.getSelectors(getReferenceDataEntitiesState);


